import loadable from '@loadable/component';
import { GalleryOptions_Layout_Type } from 'ricos-schema';
import React, { useMemo } from 'react';
import { Node_Type } from 'ricos-types';

var GALLERY_TYPE = "wix-draft-plugin-gallery";

var typeMapper = function typeMapper() {
  var _ref;
  return _ref = {}, _ref[GALLERY_TYPE] = {
    component: loadable({
      resolved: {},
      chunkName: function chunkName() {
        return "gallery-viewer";
      },
      isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
          return false;
        }
        if (typeof __webpack_modules__ !== 'undefined') {
          return !!__webpack_modules__[key];
        }
        return false;
      },
      importAsync: function importAsync() {
        return import( /* webpackChunkName: "gallery-viewer" */'./gallery-viewer.js');
      },
      requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function (resolved) {
          _this.resolved[key] = true;
          return resolved;
        });
      },
      requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (typeof __webpack_require__ !== 'undefined') {
          return __webpack_require__(id);
        }
        return eval('module.require')(id);
      },
      resolve: function resolve() {
        if (require.resolveWeak) {
          return require.resolveWeak("./gallery-viewer");
        }
        return eval('require.resolve')("./gallery-viewer");
      }
    })
  }, _ref;
};

var _layoutData, _layoutRicosData;
var layoutData = (_layoutData = {}, _layoutData[GalleryOptions_Layout_Type.COLLAGE] = {
  isVertical: true,
  oneRow: false,
  galleryType: "Columns",
  gallerySizePx: "300"
}, _layoutData[GalleryOptions_Layout_Type.MASONRY] = {
  numberOfImagesPerRow: 0,
  isVertical: false,
  gallerySizePx: "300"
}, _layoutData[GalleryOptions_Layout_Type.GRID] = {
  numberOfImagesPerRow: 3,
  cubeType: "fill",
  cubeRatio: 1,
  isVertical: true,
  oneRow: false
}, _layoutData[GalleryOptions_Layout_Type.THUMBNAIL] = {
  galleryThumbnailsAlignment: "bottom",
  thumbnailSpacings: 5
}, _layoutData[GalleryOptions_Layout_Type.SLIDER] = {
  cubeType: "fit",
  cubeRatio: "16/9"
}, _layoutData[GalleryOptions_Layout_Type.SLIDESHOW] = {
  cubeType: "fit"
}, _layoutData[GalleryOptions_Layout_Type.PANORAMA] = {
  hasThumbnails: false,
  galleryThumbnailsAlignment: "none"
}, _layoutData[GalleryOptions_Layout_Type.COLUMN] = {
  hasThumbnails: false,
  galleryThumbnailsAlignment: "none"
}, _layoutData[GalleryOptions_Layout_Type.FULLSIZE] = {
  cubeType: "fill"
}, _layoutData);
(_layoutRicosData = {}, _layoutRicosData[GalleryOptions_Layout_Type.COLLAGE] = {
  layout: {
    type: "COLLAGE",
    orientation: "COLUMNS",
    horizontalScroll: false
  },
  item: {
    crop: "FILL",
    targetSize: 300
  },
  thumbnails: {
    placement: "NONE"
  }
}, _layoutRicosData[GalleryOptions_Layout_Type.MASONRY] = {
  layout: {
    type: "MASONRY",
    orientation: "ROWS",
    numberOfColumns: 0
  },
  item: {
    crop: "FILL",
    targetSize: 300
  },
  thumbnails: {
    placement: "NONE"
  }
}, _layoutRicosData[GalleryOptions_Layout_Type.GRID] = {
  layout: {
    type: "GRID",
    orientation: "COLUMNS",
    horizontalScroll: false,
    numberOfColumns: 3
  },
  item: {
    crop: "FILL",
    ratio: 1
  },
  thumbnails: {
    placement: "NONE"
  }
}, _layoutRicosData[GalleryOptions_Layout_Type.THUMBNAIL] = {
  layout: {
    type: "THUMBNAIL",
    orientation: "ROWS"
  },
  item: {
    crop: "FILL"
  },
  thumbnails: {
    placement: "BOTTOM",
    spacing: 5
  }
}, _layoutRicosData[GalleryOptions_Layout_Type.SLIDER] = {
  layout: {
    type: "SLIDER",
    orientation: "ROWS"
  },
  item: {
    crop: "FIT",
    ratio: 16 / 9
  },
  thumbnails: {
    placement: "NONE"
  }
}, _layoutRicosData[GalleryOptions_Layout_Type.SLIDESHOW] = {
  layout: {
    type: "SLIDESHOW",
    orientation: "ROWS"
  },
  item: {
    crop: "FILL"
  },
  thumbnails: {
    placement: "NONE"
  }
}, _layoutRicosData[GalleryOptions_Layout_Type.PANORAMA] = {
  layout: {
    type: "PANORAMA",
    orientation: "ROWS"
  },
  item: {
    crop: "FILL"
  },
  thumbnails: {
    placement: "NONE"
  }
}, _layoutRicosData[GalleryOptions_Layout_Type.COLUMN] = {
  layout: {
    type: "COLUMN",
    orientation: "ROWS"
  },
  item: {
    crop: "FILL"
  },
  thumbnails: {
    placement: "NONE"
  }
}, _layoutRicosData[GalleryOptions_Layout_Type.FULLSIZE] = {
  layout: {
    type: "FULLSIZE",
    orientation: "ROWS"
  },
  item: {
    crop: "FILL"
  },
  thumbnails: {
    placement: "NONE"
  }
}, _layoutRicosData);

var _LAYOUT_FIXED_STYLES;
function _createForOfIteratorHelperLoose$2(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$2(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen); }
function _arrayLikeToArray$2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var __defProp$2 = Object.defineProperty;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$2(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2 = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$2.call(b, prop)) __defNormalProp$2(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols$2) {
    for (var _iterator = _createForOfIteratorHelperLoose$2(__getOwnPropSymbols$2(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum$2.call(b, prop)) __defNormalProp$2(a, prop, b[prop]);
    }
  }
  return a;
};
var GALLERY_ITEMS_TYPES = Object.freeze({
  IMAGE: "image",
  VIDEO: "video"
});
var HORIZONTAL_LAYOUTS = Object.freeze([GalleryOptions_Layout_Type.THUMBNAIL, GalleryOptions_Layout_Type.SLIDER, GalleryOptions_Layout_Type.SLIDESHOW, GalleryOptions_Layout_Type.COLUMN, GalleryOptions_Layout_Type.FULLSIZE]);
var sampleItems = [1, 2, 3].map(function (i) {
  return {
    metadata: {
      height: 10,
      width: 10
    },
    orderIndex: i,
    itemId: "sampleItem-" + i,
    url: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAABGdBTUEAALGPC/xhBQAAAAlwSFlzAAALEwAACxMBAJqcGAAAAVlpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IlhNUCBDb3JlIDUuNC4wIj4KICAgPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICAgICAgPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIKICAgICAgICAgICAgeG1sbnM6dGlmZj0iaHR0cDovL25zLmFkb2JlLmNvbS90aWZmLzEuMC8iPgogICAgICAgICA8dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KTMInWQAAAA1JREFUCB1jePv27X8ACVkDxyMHIvwAAAAASUVORK5CYII="
    //eslint-disable-line
  };
});

var DEFAULTS = Object.freeze({
  items: [],
  styles: __spreadValues$2({
    galleryLayout: 2
  }, layoutData[GalleryOptions_Layout_Type.GRID]),
  config: {
    alignment: "center",
    size: "content"
  }
});
var LAYOUT_FIXED_STYLES = (_LAYOUT_FIXED_STYLES = {}, _LAYOUT_FIXED_STYLES[GalleryOptions_Layout_Type.COLLAGE] = {
  galleryType: "Columns",
  imageMargin: 5
}, _LAYOUT_FIXED_STYLES[GalleryOptions_Layout_Type.MASONRY] = {
  imageMargin: 5,
  isVertical: false,
  gridStyle: 0
}, _LAYOUT_FIXED_STYLES[GalleryOptions_Layout_Type.GRID] = {
  imageResize: false,
  gridStyle: 1,
  galleryImageRatio: 2,
  imageMargin: 5
}, _LAYOUT_FIXED_STYLES[GalleryOptions_Layout_Type.THUMBNAIL] = {
  arrowsSize: 23,
  thumbnailSize: 120,
  floatingImages: 0
}, _LAYOUT_FIXED_STYLES[GalleryOptions_Layout_Type.SLIDER] = {
  arrowsSize: 23,
  imageMargin: 5
}, _LAYOUT_FIXED_STYLES[GalleryOptions_Layout_Type.SLIDESHOW] = {
  arrowsSize: 23,
  floatingImages: 0,
  slideshowInfoSize: 0
}, _LAYOUT_FIXED_STYLES[GalleryOptions_Layout_Type.PANORAMA] = {
  hasThumbnails: false,
  imageMargin: 5
}, _LAYOUT_FIXED_STYLES[GalleryOptions_Layout_Type.COLUMN] = {
  arrowsSize: 23,
  hasThumbnails: false,
  imageMargin: 5
}, _LAYOUT_FIXED_STYLES[GalleryOptions_Layout_Type.FULLSIZE] = {
  arrowsSize: 23,
  floatingImages: 0,
  slideshowInfoSize: 0
}, _LAYOUT_FIXED_STYLES);
var FIXED_STYLES = {
  gallerySizeType: "px",
  enableInfiniteScroll: true,
  titlePlacement: "SHOW_ON_HOVER",
  hoveringBehaviour: "NO_CHANGE",
  alwaysShowHover: true,
  allowHover: true,
  itemClick: "link",
  fullscreen: false,
  loveButton: false,
  allowSocial: false,
  allowDownload: false,
  mobileSwipeAnimation: "NO_EFFECT",
  gotStyleParams: true,
  videoPlay: "onClick",
  videoLoop: false,
  videoSound: true,
  hidePlay: false,
  showVideoPlayButton: true,
  showVideoControls: true
};
var getFixedStyles = function getFixedStyles(layout) {
  return __spreadValues$2(__spreadValues$2({}, FIXED_STYLES), LAYOUT_FIXED_STYLES[layout]);
};
var isHorizontalLayout = function isHorizontalLayout(_ref) {
  var galleryLayout = _ref.galleryLayout,
    oneRow = _ref.oneRow;
  return HORIZONTAL_LAYOUTS.indexOf(galleryLayout) > -1 || oneRow;
};
var FROM_LAYOUT_NUMBER = {
  0: GalleryOptions_Layout_Type.COLLAGE,
  1: GalleryOptions_Layout_Type.MASONRY,
  2: GalleryOptions_Layout_Type.GRID,
  3: GalleryOptions_Layout_Type.THUMBNAIL,
  4: GalleryOptions_Layout_Type.SLIDER,
  5: GalleryOptions_Layout_Type.SLIDESHOW,
  6: GalleryOptions_Layout_Type.PANORAMA,
  7: GalleryOptions_Layout_Type.COLUMN,
  8: GalleryOptions_Layout_Type.MAGIC,
  9: GalleryOptions_Layout_Type.FULLSIZE
};

var _nodeViewRenderers;
function _createForOfIteratorHelperLoose$1(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }
function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var __defProp$1 = Object.defineProperty;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$1(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1 = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols$1) {
    for (var _iterator = _createForOfIteratorHelperLoose$1(__getOwnPropSymbols$1(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
    }
  }
  return a;
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) {
    if (__hasOwnProp$1.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }
  if (source != null && __getOwnPropSymbols$1) {
    for (var _iterator2 = _createForOfIteratorHelperLoose$1(__getOwnPropSymbols$1(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1.call(source, prop)) target[prop] = source[prop];
    }
  }
  return target;
};
var GalleryRenderer = function GalleryRenderer(_ref) {
  var node = _ref.node,
    nodeIndex = _ref.nodeIndex,
    NodeViewContainer = _ref.NodeViewContainer;
  var Gallery = useMemo(function () {
    return loadable({
      resolved: {},
      chunkName: function chunkName() {
        return "gallery";
      },
      isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
          return false;
        }
        if (typeof __webpack_modules__ !== 'undefined') {
          return !!__webpack_modules__[key];
        }
        return false;
      },
      importAsync: function importAsync() {
        return import( /* webpackChunkName: "gallery" */'./gallery.js');
      },
      requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function (resolved) {
          _this.resolved[key] = true;
          return resolved;
        });
      },
      requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (typeof __webpack_require__ !== 'undefined') {
          return __webpack_require__(id);
        }
        return eval('module.require')(id);
      },
      resolve: function resolve() {
        if (require.resolveWeak) {
          return require.resolveWeak("./gallery");
        }
        return eval('require.resolve')("./gallery");
      }
    });
  }, []);
  return /* @__PURE__ */React.createElement(Gallery, {
    key: node.id,
    node: node,
    nodeIndex: nodeIndex,
    NodeViewContainer: NodeViewContainer
  });
};
var GalleryLoadable = function GalleryLoadable(_a) {
  var _b = _a,
    node = _b.node,
    props = __objRest(_b, ["node"]);
  return /* @__PURE__ */React.createElement(GalleryRenderer, __spreadValues$1({
    key: node.id,
    node: node
  }, props));
};
var nodeViewRenderers = (_nodeViewRenderers = {}, _nodeViewRenderers[Node_Type.GALLERY] = GalleryLoadable, _nodeViewRenderers);

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }
  return a;
};
var pluginGallery = function pluginGallery(config) {
  return {
    config: __spreadValues(__spreadValues({}, DEFAULTS.config), config),
    type: GALLERY_TYPE,
    typeMapper: typeMapper,
    nodeViewRenderers: nodeViewRenderers
  };
};

export { DEFAULTS as D, FROM_LAYOUT_NUMBER as F, GALLERY_TYPE as G, GALLERY_ITEMS_TYPES as a, getFixedStyles as g, isHorizontalLayout as i, pluginGallery as p, sampleItems as s, typeMapper as t };
